import useCanSeeAdminInfo from "@store/Hooks/AccountCenter/useCanSeeAdminInfo";
import { isAuthenticatedOrRemembered } from "@store/utilities/isAuthenticatedOrRemembered";
import { useSelector } from "react-redux";

const useIsUserAdmin = () => {
    return useSelector(() => {
        return isAuthenticatedOrRemembered() && useCanSeeAdminInfo()
    });
};
export default useIsUserAdmin;